import React, { SVGProps } from 'react'
const SvgNoUsers = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={83}
    height={75}
    aria-hidden="true"
    {...props}
  >
    <defs>
      <filter
        id="No-Users_svg__b"
        width="123.2%"
        height="122.9%"
        x="-11.6%"
        y="-10%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="No-Users_svg__d"
        width="136.1%"
        height="151.2%"
        x="-18%"
        y="-21.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="No-Users_svg__f"
        width="160.1%"
        height="159.6%"
        x="-30.1%"
        y="-25.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="No-Users_svg__h"
        width="138.7%"
        height="155.1%"
        x="-19.4%"
        y="-22.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={1.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="No-Users_svg__j"
        width="164.5%"
        height="164.2%"
        x="-32.3%"
        y="-25.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={1.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="No-Users_svg__l"
        width="134.1%"
        height="148.3%"
        x="-17%"
        y="-18.5%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="No-Users_svg__n"
        width="156.8%"
        height="156.3%"
        x="-28.4%"
        y="-21.5%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="No-Users_svg__p"
        width="195.5%"
        height="193.3%"
        x="-50%"
        y="-48.9%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={3.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <ellipse id="No-Users_svg__a" cx={34.5} cy={35.5} rx={34.5} ry={35} />
      <ellipse
        id="No-Users_svg__g"
        cx={11.115}
        cy={10.905}
        rx={10.812}
        ry={10.905}
      />
      <ellipse
        id="No-Users_svg__k"
        cx={7.966}
        cy={7.789}
        rx={7.748}
        ry={7.789}
      />
      <ellipse
        id="No-Users_svg__o"
        cx={15.375}
        cy={15.111}
        rx={14.956}
        ry={15.111}
      />
      <path
        id="No-Users_svg__e"
        d="M1.513 25.962C-2.241 9.035 3.39.57 18.406.57s20.647 8.464 16.893 25.39"
      />
      <path
        id="No-Users_svg__i"
        d="M1.084 18.544C-1.606 6.454 2.429.408 13.191.408c10.761 0 14.797 6.045 12.107 18.136"
      />
      <path
        id="No-Users_svg__m"
        d="M2.092 35.975C-3.1 12.52 4.69.791 25.462.791c20.772 0 28.562 11.728 23.368 35.184"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#EAEBF1"
        d="M73.704 8H61.207C60.54 8 60 8.54 60 9.207v1.69c0 .666.54 1.206 1.207 1.206h12.497c.667 0 1.207-.54 1.207-1.206v-1.69C74.91 8.54 74.37 8 73.704 8ZM78.704 44H46.207C45.54 44 45 44.54 45 45.207v1.69c0 .666.54 1.206 1.207 1.206h32.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207ZM26.704 51H4.207C3.54 51 3 51.54 3 52.207v1.69c0 .666.54 1.206 1.207 1.206h22.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207Z"
      />
      <g transform="translate(8 -.5)">
        <mask id="No-Users_svg__c" fill="#fff">
          <use xlinkHref="#No-Users_svg__a" />
        </mask>
        <use
          xlinkHref="#No-Users_svg__a"
          fill="#000"
          filter="url(#No-Users_svg__b)"
        />
        <use xlinkHref="#No-Users_svg__a" fill="#FCFCFF" />
        <g mask="url(#No-Users_svg__c)">
          <g transform="translate(-4.333 42.688)">
            <use
              xlinkHref="#No-Users_svg__e"
              fill="#000"
              filter="url(#No-Users_svg__d)"
            />
            <use xlinkHref="#No-Users_svg__e" fill="#3475F2" />
          </g>
          <g transform="translate(2.958 24.12)">
            <use
              xlinkHref="#No-Users_svg__g"
              fill="#000"
              filter="url(#No-Users_svg__f)"
            />
            <use xlinkHref="#No-Users_svg__g" fill="#A6C8FE" />
          </g>
        </g>
        <g mask="url(#No-Users_svg__c)">
          <g transform="translate(50.361 41.205)">
            <use
              xlinkHref="#No-Users_svg__i"
              fill="#000"
              filter="url(#No-Users_svg__h)"
            />
            <use xlinkHref="#No-Users_svg__i" fill="#BDC1C8" />
          </g>
          <g transform="translate(55.586 28.23)">
            <use
              xlinkHref="#No-Users_svg__k"
              fill="#000"
              filter="url(#No-Users_svg__j)"
            />
            <use xlinkHref="#No-Users_svg__k" fill="#D8DADE" />
          </g>
        </g>
        <g mask="url(#No-Users_svg__c)">
          <g transform="translate(9.139 43.039)">
            <use
              xlinkHref="#No-Users_svg__m"
              fill="#000"
              filter="url(#No-Users_svg__l)"
            />
            <use xlinkHref="#No-Users_svg__m" fill="#82DCC9" />
          </g>
          <g transform="translate(19.225 15.925)">
            <use
              xlinkHref="#No-Users_svg__o"
              fill="#000"
              filter="url(#No-Users_svg__n)"
            />
            <use xlinkHref="#No-Users_svg__o" fill="#00AC8E" />
          </g>
        </g>
      </g>
      <g
        strokeWidth={4}
        filter="url(#No-Users_svg__p)"
        transform="translate(38 29)"
      >
        <circle
          cx={15.333}
          cy={15.333}
          r={15.333}
          fill="#A7C9FF"
          stroke={props.stroke || 'var(--color-cta)'}
        />
        <path
          stroke={props.stroke || 'var(--color-cta)'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m25.82 26.82 15.762 15.762"
        />
      </g>
    </g>
  </svg>
)
export default SvgNoUsers
